import React from 'react';

const InvItemAttrs = (props) => {
    const { formObject, rowKey, headerKey, action } = props;

    const viewData = formObject.getFormData(rowKey, headerKey, action.paramName);
    const hide = formObject.getValueFromKey(viewData, "dataList.isHid", "0");

    if (viewData && hide === "0") {
        return (
            <div>
                {
                    Object.values(viewData.childRows).map((row) => (
                        <div className="uiRow" title={row.dataList.title}>
                            <span className="uiLbl" >{row.dataList.label}</span>
                            <span className="uiVal" >{row.val}</span>
                        </div>
                    ))
                }
            </div>
        )
    }

    return (null);
}

export default InvItemAttrs